export default {
  loginBtn: "使用 GSK 公司账户登录",
  welcomeMainMsg: "欢迎来到我们的想法箱",
  welcomeSubMsg:
    "这里是您的创意发源地。您可以提交想法，与他人协作，获取状态更新，并查看哪些项目已经完成。",
  submitIdea: "提交想法",
  andThen: "然后",
  andThenMsg: "您还可以查看其他人的想法，并给予一些建议。",
  new: "新的",
  discussion: "讨论",
  building: "建设中",
  playground: "游乐场",
  pilot: "试点",
  pilotLower: "试点",
  workInProgress: "进行中的工作",
  updates: "更新",
  viewMore: "查看更多",
  aboutGSK: "关于GSK",
  aboutGSKMsg: "GSK plc. 版权所有.",
  idea: "想法",
  submitYourIdea: "提交您的想法",
  title: "标题",
  imgCondition:
    "JPG、JPEG、PNG 或 GIF - 文件限制 5MB <br> 推荐尺寸 320x240px 或更大",
  chooseImg: "选择图片",
  chooseImgAgain: "重新选择图片",
  description: "描述",
  attachments: "附件",
  drag: "拖放 - 浏览您的电脑",
  mobileUploadMsg: "从您的移动设备上传",
  cancel: "取消",
  home: "主页",
  submit: "提交",
  browse: "浏览",
  aiportal: "AIPORTAL",
  allIdeas: "所有想法",
  showMyIdeas: "展示我的想法",
  searchAnything: "搜索任何内容...",
  operation: "操作",
  status: "状态",
  department: "部门",
  owner: "所有者",
  clear: "清除",
  collected: "已收集",
  supported: "已支持",
  commented: "已评论",
  comments: "评论",
  submitted: "已提交",
  followIdea: "关注想法",
  unfollowIdea: "取消关注想法",
  users: "用户",
  yourSuggestions: "您的建议",
  yourSuggestionsMsg: "告诉我您的建议",
  viewProfile: "查看资料",
  job: "工作",
  ideas: "想法",
  noSubmissions: "没有提交的内容.",
  myIdeas: "我的想法",
  myComments: "我的评论",
  firstName: "名字",
  lastName: "姓氏",
  email: "电子邮件",
  oldPassword: "旧密码",
  newPassword: "新密码",
  confirmPassword: "确认密码",
  passwordMsg: "您的新密码不一致.",
  userPool: "用户池",
  ideasManagement: "想法管理",
  createTime: "创建时间",
  lastUpdate: "最后更新",
  detail: "详情",
  action: "行动",
  searchIdeaName: "搜索想法名称...",
  commentsDetail: "评论详情",
  likesUserList: "点赞用户列表",
  reply: "回复",
  replyMsg: "在这里发送您的评论...",
  onlyAdmin: "仅管理员",
  manageAuthority: "管理权限",
  submitLower: "提交",
  edit: "编辑",
  delete: "删除",
  confirm: "确认",
  applyMsg:
    "管理员申请审批后，将会通过邮件通知您，<br />确认发起管理员权限申请吗？",
  adminUser: "管理员用户",
  playgroundLower: "游乐场",
  followIdeaMsg: "关注想法并发送每周进展报告到邮箱.",
  userName: "用户名",
  lastLoginTime: "最后登录时间",
  creativeIdeas: "创意想法",
  approve: "批准",
  reject: "拒绝",
  logout: "注销",
  ideasUpper: "想法",
  noCommentData: "暂无评论数据",
  justNow: "刚刚",
  minute: "分钟",
  minutes: "分钟",
  hour: "小时",
  hours: "小时",
  day: "天",
  days: "天",
  week: "周",
  weeks: "周",
  month: "月",
  months: "月",
  year: "年",
  years: "年",
  ago: "前",
  CreatedBy: "所有者",
  Collects: "收藏",
  Likes: "点赞",
  reset: "重置",
  statistics: "统计",
  allTime: "全部时间",
  withinayear: "一年内",
  withinsixmonths: "六个月内",
  sum: "总计",
  exportExcel: "导出Excel",
  warning: "警告",
  Warning: "警告",
  warningmsg: "此操作将导致永久删除。继续吗？",
  deletesuccess: "删除成功",
  deletecancel: "取消删除",
  submit_warning: "请勿上传个人信息和GSK敏感数据。",
  category: "类别",
  tag: "标签",
  categoryMgt: "类别管理",
  tagMgt: "标签管理",
  addCategory: "添加类别",
  addTag: "添加标签",
  categoryName: "类别名称",
  inputMsg: "请输入",
  categoryExist: "类别已存在",
  tagExist: "标签已存在",
  disable: "禁用",
  disableSuccess: "禁用成功",
  disableMsg: "确定禁用吗？",
  enableMsg: "确定启用吗？",
  tagName: "标签名称",
  selectMsg: "请选择",
  loading: "加载中...",
  addSuccess: "添加成功",
  tagLimit: "您最多只能添加5个标签",
  enableSuccess: "启用成功",
  submitFailed: "提交失败，请稍后重试",
  submitSuccess: "提交成功",
  languageMsg: "你想显示哪种语言？",
  likeTime: "点赞时间",
  AiPortalSetting: {
    banner: "欢迎来到GSK研发AI门户，在这里您可以找到GSK中国研发部门支持的所有AI产品。欢迎您使用并提供宝贵意见",
    personalAssistant: "个人AI助理",
    personalAssistantDesc: "基于大语言模型的个性化AI助理，帮助用户研究知识、完成日常任务并与同事协作，释放时间让您更具创造力和生产力。",
    knowledgeResearch: "知识研究",
    dailyTasks: "日常任务",
    collaborate: "协作",
    goToThePager: "前往页面",
    hi: "您好",
    autoProofreading: "自动校对",
    autoProofreadingDesc: "我们的生成式AI自动校对项目旨在通过先进的校对能力革新文档翻译质量，缩短周期时间，降低成本，确保高质量输出。这将加速新药申请的全球市场准入，特别是在日本和中国。通过自动化翻译和校对流程，我们将显著减少翻译周期时间，消除大量手工校对需求，并确保法规合规性。",
    meetGiGi: "认识GiGi",
    giGiDesc: "我们的数字助理",
    giGiCapabilities: "GiGi可以帮助您更快速、轻松地完成工作，从创建书面内容、回答公司政策问题、分析和翻译文档到管理任务和审批。",
    jules: "认识Jules",
    julesDesc: "Jules是专为研发量身定制的AI助理。Jules旨在通过由生成式AI提供支持的一流科学推理能力来帮助您加速工作。Jules可以回答一般问题以及有关文档的问题。Jules即将可以访问精选数据源，因此您可以查询和分析数据。",
    comingSoon: "即将上线",
    goNow: "立即前往",
    add: "添加",
    addModule: "添加模块",
    editModule: "编辑模块",
    logo: "LOGO",
    title: "标题",
    name: "名称",
    description: "描述",
    buttonName: "按钮名称",
    buttonUrl: "按钮链接",
    buttonUrlPlaceholder: "请输入按钮跳转链接",
    backgroundImage: "背景图片",
    status: "状态",
    type: "类型",
    online: "上线",
    preparing: "准备中",
    assistant: "背景灰",
    tool: "背景白",
    titleRequired: "请输入标题",
    AIPm: "AI门户管理",
    MIM: "模型介绍管理",
  }
};
